import { useIntParams } from "core/model/utils/urls";
import { ClinicalConsultation, Patient, QueryProgress } from "core/types";
import { doctorDashboardRedirectPath } from "entries/sender/Router/paths";
import { Navigate, Outlet, useOutletContext } from "react-router-dom";

/** Context provided by ClinicalConsultationsRoute (consultation/* route). */
export type ConsultationsContext = {
  clinicalConsultations: ClinicalConsultation[];
  clinicalConsultationsProgress: QueryProgress;
  patient: Patient;
};

export function useConsultationsContext(): ConsultationsContext {
  const context = useOutletContext<ConsultationsContext>();
  if (!context) {
    throw new Error(
      "useConsultationsContext must be used within ClinicalConsultationsRoute",
    );
  }
  return context;
}

/** Context provided by ConsultationLayout (:consultationId route). */
export type ConsultationContext = {
  consultation: ClinicalConsultation;
  patient: Patient;
};

export function useConsultationContext(): ConsultationContext {
  const context = useOutletContext<ConsultationContext>();
  if (!context?.consultation) {
    throw new Error(
      "useConsultationContext must be used within ConsultationLayout",
    );
  }
  return context;
}

export default function ConsultationLayout() {
  const context = useConsultationsContext();
  const { consultationId } = useIntParams<{ consultationId: number }>();
  const consultation = context.clinicalConsultations.find(
    (c) => c.id === consultationId,
  );

  if (consultation == null) {
    return <Navigate replace to={doctorDashboardRedirectPath} />;
  }

  return <Outlet context={{ ...context, consultation }} />;
}
